import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';
import './workspace-theme.css';
import './login-theme.css';
import './component-system.css';
import App from './App';

createRoot(document.getElementById('root')).render(<App />);
